import React from 'react';
import DataTable from '../DataTable/DataTable';

// Table without a title bar; `removeMargin` attaches it flush under a heading
// the caller draws. See DataTable.
export default function CustomTableWithoutHeader({
  tableHead, itemComponent, noDataText, removeMargin, pages, bare,
}) {
  return (
    <DataTable
      flush={removeMargin}
      squareTop={removeMargin}
      tableHead={tableHead}
      itemComponent={itemComponent}
      noDataText={noDataText}
      paginate={pages !== false}
      bare={bare}
    />
  );
}
